<template>
  <div class="control-group">
    <label class="control control-checkbox">
      <span
        :style="checkedBox ? 'font-weight:600;' : 'font-weight:400;'"
        >{{ title }}</span
      >
      <input @change="newCheck" type="checkbox" :checked="checkedBox" />
      <div class="control_indicator"></div>
    </label>
  </div>
</template>
<script>
export default {
  name: "CustomCheckbox",
  props: ["title", "checked"],
  emits: ["check"],
  data() {
    return {
      checkedBox: this.checked,
    };
  },
  watch:{
    checked(){
        this.checkedBox = this.checked
    }
  },
  methods: {
    newCheck() {
      this.$emit("check", !this.checkedBox);
      this.checkedBox = !this.checkedBox
    },
  },
};
</script>
<style scoped>
.control {
  display: block;
  position: relative;
  padding-left: 43px;
  margin-bottom: 5px;
  padding-top: 0px;
  cursor: pointer;
  font-size: 16px;
  line-height: 24px;
  font-style: normal;
  color: #090741;
}
.control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.control_indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 20px;
  width: 20px;
  background: #fff;
  border: 1px solid #090741;
  border-radius: 5px;
}
.control:hover input ~ .control_indicator,
.control input:focus ~ .control_indicator {
  background: #fff;
}

.control input:checked ~ .control_indicator {
  background: rgb(235, 42, 106);
  background: linear-gradient(
    140deg,
    rgba(235, 42, 106, 1) 0%,
    rgba(242, 82, 78, 1) 49%,
    rgba(250, 131, 45, 1) 100%
  );
  border: none;
}
.control:hover input:not([disabled]):checked ~ .control_indicator,
.control input:checked:focus ~ .control_indicator {
  background: rgb(235, 42, 106);
  background: linear-gradient(
    140deg,
    rgba(235, 42, 106, 1) 0%,
    rgba(242, 82, 78, 1) 49%,
    rgba(250, 131, 45, 1) 100%
  );
  border: none;
}
.control input:disabled ~ .control_indicator {
  background: #e6e6e6;
  opacity: 0.6;
  pointer-events: none;
}
.control_indicator:after {
  box-sizing: unset;
  content: "";
  position: absolute;
  display: none;
}
.control input:checked ~ .control_indicator:after {
  display: block;
}
.control-checkbox .control_indicator:after {
  left: 7px;
  top: 5px;
  width: 4px;
  height: 7px;
  border: solid #ffffff;
  border-width: 0 1.5px 1.5px 0;
  transform: rotate(45deg);
}
.control-checkbox input:disabled ~ .control_indicator:after {
  border-color: #7b7b7b;
}
</style>
